/**
 * Project-wide constants.
 * Working name: Pulsewright. Change PROJECT_NAME and FILE_EXTENSION here to rename.
 */

export const PROJECT_NAME = 'Pulsewright';
export const FILE_EXTENSION = 'pwt';
export const PROJECT_MIME = 'application/x-pulsewright+json';

/** Current schema version for the .pwt project file. */
export const PROJECT_SCHEMA_VERSION = 1 as const;

/** Default pattern length in rows. */
export const DEFAULT_PATTERN_LENGTH = 64;

/** Default ticks-per-row (FamiTracker speed). */
export const DEFAULT_SPEED = 6;

/** Default tempo (BPM-equivalent). */
export const DEFAULT_TEMPO = 150;

/** Hardware reference values for the NTSC NES 2A03. */
export const NES = {
  CPU_CLOCK_HZ: 1789773,
  FRAME_RATE_HZ: 60.0988,
  // 16-entry noise period table (NTSC). Lower index = higher pitch.
  NOISE_PERIOD_TABLE: [
    4, 8, 16, 32, 64, 96, 128, 160, 202, 254, 380, 508, 762, 1016, 2034, 4068,
  ] as const,
  // 16-entry DPCM rate table (NTSC), in CPU cycles per output bit.
  DPCM_RATE_TABLE: [
    428, 380, 340, 320, 286, 254, 226, 214, 190, 160, 142, 128, 106, 84, 72, 54,
  ] as const,
} as const;

export const CHANNEL_TYPES = ['pulse', 'triangle', 'noise', 'dpcm'] as const;
export type ChannelType = (typeof CHANNEL_TYPES)[number];

export const PATTERN_CHANNELS = ['pulse1', 'pulse2', 'triangle', 'noise', 'dpcm'] as const;
export type PatternChannel = (typeof PATTERN_CHANNELS)[number];
